import { render, staticRenderFns } from "./PaymentsCard.vue?vue&type=template&id=6317195d&scoped=true&lang=pug&"
import script from "./PaymentsCard.vue?vue&type=script&lang=ts&"
export * from "./PaymentsCard.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentsCard.vue?vue&type=style&index=0&id=6317195d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6317195d",
  null
  
)

export default component.exports